<template>
  <v-app-bar color="primary" dark flat dense>
    <v-btn icon @click="Back(app_url)" aria-label="Back">
      <v-icon>{{ backIcon }}</v-icon>
    </v-btn>

    <v-spacer></v-spacer>
    <div class="toolbar-custom__title">{{ app_title }}</div>
    <v-spacer></v-spacer>

    <v-btn v-if="showHelp" icon @click="Help" aria-label="Help">
      <v-icon>mdi-lifebuoy</v-icon>
    </v-btn>
    <span v-else class="toolbar-custom__placeholder"></span>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    app_title: {
      type: String,
      default: ""
    },
    app_url: {
      type: String,
      default: ""
    },
    app_icon: {
      type: String,
      default: "mdi-arrow-left"
    },
    app_help: {
      type: String,
      default: "N"
    }
  },
  computed: {
    backIcon() {
      const icon = (this.app_icon || "").trim();
      const iconMap = {
        clear: "mdi-close",
        close: "mdi-close",
        arrow_back: "mdi-arrow-left",
        keyboard_backspace: "mdi-arrow-left"
      };
      if (iconMap[icon]) {
        return iconMap[icon];
      }
      return icon.startsWith("mdi-") ? icon : "mdi-close";
    },
    showHelp() {
      return this.app_help === "Y";
    }
  },
  methods: {
    Help() {
      this.$router.push({ name: "help" });
    },
    Back(names) {
      if (names) {
        this.$router.push({ name: names });
        return;
      }
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.toolbar-custom__title {
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: center;
}

.toolbar-custom__placeholder {
  width: 40px;
  display: inline-block;
}
</style>